import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

/**
 * Emits <link rel="canonical" href="https://luxsova.in/<path>"> on every
 * route change. Purpose: we run both `luxsova.com` and `luxsova.in`
 * serving identical content — this tag tells Google which URL to index,
 * consolidating all SEO signals under the `.in` brand and avoiding the
 * duplicate-content penalty that would otherwise split rankings.
 *
 * Query strings are intentionally stripped from the canonical URL because
 * they're typically tracking/UTM/session junk that shouldn't spawn a new
 * indexable variant. Product/category paths are already unique on their own.
 *
 * Mounted once inside `<HelmetProvider>` in App.js — no per-page config.
 */
const CANONICAL_HOST = "https://luxsova.in";

const CanonicalTag = () => {
  const { pathname } = useLocation();
  const url = `${CANONICAL_HOST}${pathname === "/" ? "/" : pathname}`;
  return (
    <Helmet>
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default CanonicalTag;
